import { ReactComponent as AppIcon } from '../../../assets/icons/app_icon.svg';
import { ReactComponent as CheckCircleIcon } from '../../../assets/icons/checkbox-circle-fill.svg';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close-line.svg';
import { useLocale } from '../../../context/NbLocalizationContext';
import { cssWhen } from '../../utils/themeUtils';
import { NbIconButton } from '../icon-button/IconButton';
import classes from './MobileAppBannerContent.module.scss';

type MobileAppBannerContentProps = {
  onDismiss?: () => void;
  isFullScreen?: boolean;
};

export const MobileAppBannerContent = ({ onDismiss, isFullScreen }: MobileAppBannerContentProps) => {
  const { translation } = useLocale();

  const featureItems = [
    translation.mobileAppBanner.item1,
    translation.mobileAppBanner.item2,
    translation.mobileAppBanner.item3,
  ];

  return (
    <div className={classes.content}>
      <div className={classes.header}>
        <AppIcon className={classes.appIcon} />
        <span className={cssWhen(classes.title, [isFullScreen, classes.titleIsFullScreen])}>
          {translation.mobileAppBanner.title}
        </span>
        {onDismiss && (
          <NbIconButton
            className={classes.closeButton}
            icon={<CloseIcon />}
            onClick={onDismiss}
          />
        )}
      </div>
      <div className={classes.featureList}>
        {featureItems.map((item, index) => (
          <div
            key={index}
            className={classes.featureRow}
          >
            <CheckCircleIcon className={classes.featureRowIcon} />
            <span className={cssWhen(classes.featureRowText, [isFullScreen, classes.featureRowTextIsFullScreen])}>
              {item}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
